import React, { PureComponent } from 'react'
import { BrowserRouter as Router, Route } from "react-router-dom"
import { Pane, Spinner } from "evergreen-ui"

import * as Sentry from '@sentry/browser';

import Home from './routes/Home/Home'
import Profile from './routes/Profile/Profile'

// import History from './routes/History/History'
// import HeatMap from './routes/Heatmaps/Heatmaps'
// import Recorded from './routes/Recorded/Recorded'

import Navbar from './components/Navbar/Navbar'
import Auth from './Auth'

import Datafetcher, { getUserResponseInterface } from './utils/datafetcher'
import { User, Camera } from './types'


interface Props {
    datafetcher: Datafetcher
}

interface State {
    tourDone: boolean,
    user: User,
    cameras: Camera[]
}

export default class AppRouter extends PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);

        const tDone = localStorage.getItem('tourDone')

        this.state = {
            cameras: [],
            user: {
                name: "",
                email: "",
                paymentSaved: false,
                zapierKey: "",
                expoToken: ""
            },
            tourDone: tDone === "true" ? true : false
        }
    }

    componentDidMount() {
        this.cameraRefresher()
    }

    cameraRefresher() {
        this.refreshInfo()
        setTimeout(() => this.cameraRefresher(), 60 * 1000);
    }
    

    refreshInfo = () => {
        this.props.datafetcher.getUserInfo((err: Error | null, resp: getUserResponseInterface | null) => {
            if (err) {
                (new Auth()).logout();
                return
            }
            if (!resp || !resp.data){return}
            const {user, cameras} = resp.data
            if (user) {
                Sentry.configureScope(function (scope) {
                    scope.setUser({ "email": resp.data.user.email });
                })
            }
            if (cameras && cameras.length > 0) {
                // this.props.datafetcher.getCameraTags(cameras[0].id, (err: Error | null, camResp: getCameraTagsResponseInterface | null) => {
                //     if (!camResp) { throw err }
                    this.setState({
                        user: resp.data.user,
                        cameras: cameras,
                    })
                // })
            } else {
                this.setState({
                    user: resp.data.user,
                    cameras: [],
                })
            }
        })
    }

    render() {
        return !this.state.user ?
            <Pane display="flex" alignItems="center" flexDirection="column">
                <Pane borderRadius={10} elevation={1} background="white" padding={25} marginTop="30vh" marginBottom="30vh" display="flex" alignItems="center" flexDirection="row">
                    <Spinner size={128} />
                </Pane>
            </Pane>
            :
            <>
                {/* <Tour
                    steps={steps}
                    isOpen={false && !this.state.tourDone}
                    goToStep={this.state.tourStep}
                    onRequestClose={target => {
                        localStorage.setItem('tourDone', true)
                        this.setState({ tourDone: true })
                        return true
                    }}
                /> */}
                <Router>
                    <Navbar user={this.state.user}></Navbar>
                    <Route path="/" exact>
                        <Home datafetcher={this.props.datafetcher} refreshInfo={this.refreshInfo} user={this.state.user} cameras={this.state.cameras}></Home>
                    </Route>
                    {/* <Route path="/heatmap">
                        <HeatMap datafetcher={this.datafetcher} refreshInfo={this.refreshInfo} user={this.state.user} cameras={this.state.cameras}></HeatMap>
                    </Route>
                    <Route path="/recorded">
                        <Recorded datafetcher={this.datafetcher} refreshInfo={this.refreshInfo} user={this.state.user} cameras={this.state.cameras}></Recorded>
                    </Route>
                    <Route path="/history">
                        <History datafetcher={this.datafetcher} refreshInfo={this.refreshInfo} user={this.state.user} cameras={this.state.cameras}></History>
                    </Route> */}
                    <Route path="/profile">
                        <Profile datafetcher={this.props.datafetcher} user={this.state.user}></Profile>
                    </Route>
                </Router>
            </>
    }
}